import { type ReactNode } from 'react';
import { Clock } from 'lucide-react';
import type { Payment } from '../types';
import { formatUSD, formatPeriod } from '../utils/payment-formatters';

function Badge({ status }: { status: string }): ReactNode {
  const paid = status === 'paid';
  const cls = paid ? 'bg-success/10 text-success' : 'bg-error/10 text-error';
  return (
    <span className={`rounded px-1.5 py-0.5 text-[9px] font-medium ${cls}`}>
      {paid ? 'Pagado' : 'Pendiente'}
    </span>
  );
}

function Row({ p }: { p: Payment }): ReactNode {
  return (
    <div className="flex items-center justify-between py-2.5">
      <div className="min-w-0">
        <p className="text-[11px] text-text-secondary">
          {formatPeriod(p.period_start, p.period_end)}
        </p>
        <p className="mt-0.5 text-[10px] text-text-tertiary/60">
          {p.lead_count} creadores
        </p>
      </div>
      <div className="flex items-center gap-md">
        <span className="font-mono text-[13px] font-semibold tabular-nums text-text-primary">
          {formatUSD(p.total_earnings)}
        </span>
        <Badge status={p.status} />
      </div>
    </div>
  );
}

export function PaymentHistoryList({
  payments,
}: {
  payments: Payment[];
}): ReactNode {
  const paid = payments.filter((p) => p.status === 'paid');
  if (!paid.length) return null;
  return (
    <div className="rounded-xl bg-white/[0.02] p-base">
      <div className="flex items-center gap-sm">
        <Clock size={14} className="text-text-tertiary/50" />
        <span className="text-[10px] font-medium uppercase tracking-wider text-text-tertiary/50">
          Historial de pagos
        </span>
      </div>
      <div className="mt-sm divide-y divide-white/[0.03]">
        {paid.map((p) => (
          <Row key={p.id} p={p} />
        ))}
      </div>
    </div>
  );
}
